// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../config/screen';

export const LeftMetricsContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  flex: 1;
  height: 100%;
`;

export const RightMetricsContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  flex: 1;
  height: 100%;
`;

export const VSIMonitoringContainer = styled.div`
  background-color: ${({ theme }) => theme.color.crusherDashboard.crusherDashboardBackgroundColor};
  padding: 0.75rem 0.75rem 1rem 0.75rem;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  height: auto;

  @media (min-width: ${BREAKPOINTS.xl}px) {
    height: 100%;
  };
`;

export const AlertContainer = styled.div`
  padding: 0;

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 0 0.375rem 0 0.125rem;
  };
`;

export const BinFeederAndVibrationContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-right: 8px;
`;

export const MotorStatusContainer = styled.div`
  display: flex;
  gap: 8px;
`;
